export default __webpack_public_path__ + "static/media/RunHorseLight_6_1.3b342eaf.jpg";